import {
   ADD_CUSTOMER_REGISTOR,
   ADD_ORDER,
   GET_DASHBOARD_COUNT,
   GET_GLOBAL_SETTING,
   GET_PACKAGE,
   GET_PACKAGE_CUSTOMER,
   GET_SETTING_FOR_WEB,
   UPDATE_PACKAGE_CUSTOMER,
   VALIDATE_CUSTOMER,
   GET_BUSINESS_COUNT
} from '../types';
import axios from '../../axios';
import { toast } from 'react-toastify';

export const getPackage = () => async (dispatch) => {
   try {
      const res = await axios.get(`/package/all`);

      //   console.log('res', res.data.data);

      if (res.data.code === 1) {
         dispatch({
            type: GET_PACKAGE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};
export const getPackageForWeb = () => async (dispatch) => {
   try {
      const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/package/all`);
      //   console.log('res', res.data.data);

      if (res.data.code === 1) {
         dispatch({
            type: GET_PACKAGE,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const validateCustomer = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/customer/validate`, formData);
      console.log('Validation API Response:', res.data);

      if (res.data.code === 1) {
         dispatch({
            type: VALIDATE_CUSTOMER,
            payload: res.data.data,
         });
         toast.success(res.data.message);
      }
      if (res.data.code === 2) {
         toast.warn(res.data.message);
      }
      return res.data;
   } catch (err) {
      console.error('Validation API Error:', err);

      let errorMessage = 'An error occurred during validation';

      if (err.response?.data?.errors?.[0]?.message) {
         errorMessage = err.response.data.errors[0].message;
      } else if (err.response?.data?.message) {
         errorMessage = err.response.data.message;
      } else if (err.message) {
         errorMessage = err.message;
      }

      toast.error(errorMessage);
      return {
         code: 0,
         message: errorMessage,
         data: false,
      };
   }
};
export const addCustomer = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/customer/add`, formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_CUSTOMER_REGISTOR, payload: res.data.data });
         setTimeout(() => {
            toast.success('Customer added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }

      return res.data;
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }

      throw err;
   }
};

export const getDashboardCount = () => async (dispatch) => {
   try {
      const res = await axios.get(`/dashboard/counts`);

      if (res.data.code === 1) {
         dispatch({
            type: GET_DASHBOARD_COUNT,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSettingForWeb = () => async (dispatch) => {
   try {
      const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/settings/all`);

      if (res.data.code === 1) {
         dispatch({
            type: GET_SETTING_FOR_WEB,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const AddOrder = (orderData) => async (dispatch) => {
   try {
      const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/packageTransaction/addOrder`, orderData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_ORDER, payload: res.data.data });
         setTimeout(() => {
            // toast.success('Customer added successfully!');
         }, 1000);
         return res.data;
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getGlobalSetting = () => async (dispatch) => {
   try {
      const res = await axios.get(`/settings/global`);

      //   console.log('res', res.data.data);

      if (res.data.code === 1) {
         dispatch({
            type: GET_GLOBAL_SETTING,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getCustomerFormPackage = () => async (dispatch) => {
   try {
      const res = await axios.get(`/user/customer`);

      //   console.log('res', res.data.data);

      if (res.data.code === 1) {
         dispatch({
            type: GET_PACKAGE_CUSTOMER,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateCustomerFormPackage = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/user/customer/update`, formData);

      if (res.data.code === 1) {
         dispatch({
            type: UPDATE_PACKAGE_CUSTOMER,
            payload: res.data,
         });
         toast.success(res.data.message || 'Update successful');

         return { success: true, data: res.data };
      }

      if (res.data.code === 2) {
         toast.warn(res.data.message || 'Update failed');
         return { success: false, message: res.data.message };
      }
   } catch (err) {
      if (err.response && err.response.data) {
         const errorData = err.response.data;
         if (errorData.message) {
            toast.error(errorData.message);
         }
      }
      return { success: false, error: err };
   }
};


export const getBusinessCount = () => async (dispatch) => {
   try {
      const res = await axios.get(`/business-count/all`, {
         headers: {
            Authorization: `Bearer essential`,
         },
      });

      if (res.data.code === 1) {
         dispatch({
            type: GET_BUSINESS_COUNT,
            payload: {
               data: res.data.data || [],
            },
         });
      }
   } catch (err) {
      if (err.response?.data?.errors?.[0]?.message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};